export default __webpack_public_path__ + "static/media/small-size-quadrants.fc053e98.png";